// import React, { useContext, useEffect, useState } from 'react';
// import ProfileDropdown from './ProfileDropdown';
// import SettingsAnimatedIcon from './SettingsAnimatedIcon';
// import { getuserStatus, postuserStatus } from '../../Redux/Actions/USER/user';
// import AppContext from '../../context/Context';
// import classNames from 'classnames';
// import { navbarBreakPoint } from '../../config';
// import { connect } from 'react-redux';
// import { notification } from '../../routes';
// import { Collapse, Nav, NavItem } from 'reactstrap';
// import { NavLink, withRouter } from 'react-router-dom';
// import { readunread } from '../../Redux/Actions/Mask/Mask';
// import {Device} from '@twilio/voice-sdk';
// import NavbarVerticalMenuItem from './NavbarVerticalMenuItem';
// import io from 'socket.io-client';
// import { socket } from '../../view/pages/Main/socket';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// const TopNavRightSideNavItem = ({ getuserStatus, postuserStatus, toggle, readunread,isPaid }) => {
//   const [checked, setchecked] = useState(false);
//   const { isTopNav, isCombo } = useContext(AppContext);
//   const [count, setcount] = useState([])
//   const [user, setuser] = useState()
//   const [modalContent, setModalContent] = useState(null);


//   useEffect(() => {
//     getuserStatus();
//     if (toggle != checked) {
//       setchecked(toggle);
//     }
//     getuserStatus();
//     socket.emit( "notification", localStorage.getItem("email"))

//   }, [getuserStatus, postuserStatus]);
 
//   socket.on('notificationbadge', ({exist,user}) => {
    
    
//     setcount(exist);
//     setuser(user)
//   });


//   const handleChange = event => {
//     postuserStatus(event);
//     setchecked(event);


//     if (!event) {
//       setModalContent(
//         'Now the inbound calls will not be received in Mergecall. Either the call flow will be triggered if assigned or the call will be forwarded to the assigned forwarded number.'
//       );
//     } else {
//       setModalContent(
//         'Now the inbound calls will be received in Mergecall itself. Neither the call flow will be triggered if assigned nor the call will be forwarded to the assigned forwarded number.'
//       );
//     }
//   };


//   const closeModal = () => {
//     setModalContent(null);
//   };



//   return (
    
//     <Nav navbar className="navbar-nav-icons ml-auto flex-row align-items-center">

//        <div className="p-2">
//         <NavItem>
//           <NavLink onClick={()=>{
            
//             readunread(user);
//           }} className="nav-link" {...notification}>
//             <NavbarVerticalMenuItem  route={{...notification,badge:{text:Object.values(count).filter(n=>n.status===true).length,color:"danger"}}} />
//           </NavLink>
//         </NavItem>
//       </div>
//       <div className="p-2">
//         {toggle && isPaid ? (
//           <div className="btn btn-success btn-sm" onClick={() => handleChange(false)}>
//             {' '}
//             Online
//           </div> 
//         ) : isPaid ? (
//           <div className="btn btn-danger btn-sm" onClick={() => handleChange(true)}>
//             {' '}
//             Offline
//           </div>
//         ) : null}
//       </div>

//       {modalContent && (
//         <div className="modal-backdrop" onClick={closeModal}>
//           <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//             <p style={{fontSize:'16px'}}>{modalContent}</p>
//             <button onClick={closeModal} className="btn btn-primary btn-sm" style={{fontSize:'20px'}}>I Understood</button>
//           </div>
//         </div>
//       )}

//       <style jsx>{`
//         .modal-backdrop {
//           position: fixed;
//           top: 0;
//           left: 0;
//           width: 100%;
//           height: 100%;
//           background: rgba(0, 0, 0, 0.5);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           z-index: 1000;
//         }

//         .modal-content {
//           background: white;
//           padding: 20px;
//           border-radius: 8px;
//           box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
//           text-align: center;
       
//           max-width: 600px; /* Optional: Add a maximum width for larger screens */
//           margin: 0 auto; /* Ensure centering in narrow viewports */

//         }

//         .btn {
//           cursor: pointer;
//           margin: 5px;
//         }
//       `}</style>

    
//       {(isCombo || isTopNav) && (
//         <NavItem className={classNames(`p-2 px-lg-0 cursor-pointer`, { [`d-${navbarBreakPoint}-none`]: isCombo })}>
    
//         </NavItem>
//       )}

//       <ProfileDropdown />
//     </Nav>
//   );
// };
// const mapStateToProps = state => ({
//   toggle: state.Twilio.toggle,
//   isPaid: state.auth.isPaid,
//   isAuthenticated: state.auth.isAuthenticated
// });
// export default connect(
//   mapStateToProps,
//   { getuserStatus, postuserStatus,readunread }
// )(TopNavRightSideNavItem);


import React, { useContext, useEffect, useState } from 'react';
import ProfileDropdown from './ProfileDropdown';
import SettingsAnimatedIcon from './SettingsAnimatedIcon';
import { getuserStatus, postuserStatus } from '../../Redux/Actions/USER/user';
import AppContext from '../../context/Context';
import classNames from 'classnames';
import { navbarBreakPoint } from '../../config';
import { connect } from 'react-redux';
import { notification } from '../../routes';
import { Collapse, Nav, NavItem } from 'reactstrap';
import { NavLink, withRouter } from 'react-router-dom';
import { readunread } from '../../Redux/Actions/Mask/Mask';
import { Device } from '@twilio/voice-sdk';
import NavbarVerticalMenuItem from './NavbarVerticalMenuItem';
import { socket } from '../../view/pages/Main/socket';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// ✅ NEW: AI settings actions
import { fetchAISettings, updateAISettings } from '../../Redux/Actions/AI/aiSettings';


const TopNavRightSideNavItem = ({
  getuserStatus,
  postuserStatus,
  toggle,
  readunread,
  isPaid,

  // ✅ NEW: redux state from aiSettings slice
  ai_sense,
  ai_listen,
  aiSettingsLoading,

  // ✅ NEW: actions
  fetchAISettings,
  updateAISettings
}) => {
  const [checked, setchecked] = useState(false);
  const { isTopNav, isCombo } = useContext(AppContext);
  const [count, setcount] = useState([]);
  const [user, setuser] = useState();
  const [modalContent, setModalContent] = useState(null);

  // ✅ NEW: which action is pending? ('sense-on' | 'sense-off' | 'listen-on' | 'listen-off')
  const [pendingAction, setPendingAction] = useState(null);

  // Keep existing behavior
  useEffect(() => {
    getuserStatus();
    if (toggle !== checked) setchecked(toggle);
    getuserStatus();
    socket.emit('notification', localStorage.getItem('email'));

    // ✅ NEW: fetch AI Sense/Listen on render
    fetchAISettings();
  }, [getuserStatus, postuserStatus, fetchAISettings]);

  socket.on('notificationbadge', ({ exist, user }) => {
    setcount(exist);
    setuser(user);
  });

  const handleChange = event => {
    postuserStatus(event);
    setchecked(event);

    if (!event) {
      setModalContent(
        'Inbound calls will no longer be received in Mergecall. If a call flow is configured it will be triggered, or the call will be forwarded to the assigned number.'
      );
    } else {
      setModalContent(
        'Inbound calls will now be received directly in Mergecall. Neither the assigned call flow nor call forwarding will be triggered.'
      );
    }
  };

  // ✅ NEW: Handlers for AI Sense button
  const handleToggleAISense = () => {
    if (!isPaid) return;

    if (ai_sense) {
      setPendingAction('sense-off');
      setModalContent(
        'You are about to turn OFF AI Sense. This will also stop AI Listen from monitoring Conversations & AI Live Calls. Are you sure you want to proceed?'
      );
    } else {
      setPendingAction('sense-on');
      setModalContent(
        'You are about to turn ON AI Sense. This will also enable AI Listen to start monitoring Conversations & AI Live Calls. Do you want to continue?'
      );
    }
  };

  // ✅ NEW: Optional—direct AI Listen toggle (only when Sense is active)
  const handleToggleAIListen = () => {
    if (!ai_sense || !isPaid) return;
    if (ai_listen) {
      setPendingAction('listen-off');
      setModalContent('AI Listen will stop monitoring Conversations & AI Live Calls. Do you want to turn it OFF?');
    } else {
      setPendingAction('listen-on');
      setModalContent('AI Listen will start monitoring Conversations & AI Live Calls. Do you want to turn it ON?');
    }
  };

  const closeModal = () => {
    setModalContent(null);
    setPendingAction(null);
  };

  const confirmModal = async () => {
    try {
      if (pendingAction === 'sense-off') {
        await updateAISettings({ ai_sense: false, ai_listen: false });
      } else if (pendingAction === 'sense-on') {
        await updateAISettings({ ai_sense: true, ai_listen: true });
      } else if (pendingAction === 'listen-off') {
        await updateAISettings({ ai_listen: false });
      } else if (pendingAction === 'listen-on') {
        await updateAISettings({ ai_listen: true });
      }
    } finally {
      closeModal();
    }
  };

  // ✅ Classes matching your Online/Offline visual language
  const senseBtnClass = ai_sense && isPaid ? 'btn btn-success btn-sm' : 'btn btn-danger btn-sm';
  const senseLabel = ai_sense ? 'AI Sense: On' : 'AI Sense: Off';

  return (
    <Nav navbar className="navbar-nav-icons ml-auto flex-row align-items-center">


      {/* ✅ NEW: AI Sense button */}
      <div className="p-2">
        {isPaid ? (
          <div
            className={classNames(senseBtnClass, 'ai-sense-chip')}
            onClick={handleToggleAISense}
            role="button"
            aria-label="Toggle AI Sense"
            title="Toggle AI Sense"
            style={{ minWidth: 120, textAlign: 'center' }}
          >
            {senseLabel}
          </div>
        ) : null}
      </div>

      {/* ✅ NEW: AI Listen checkbox (enabled only if AI Sense is active) */}
      <div className="p-2 d-flex align-items-center">
        {isPaid ? (
          <label className="d-flex align-items-center m-0" style={{ userSelect: 'none', gap: 8 }}>
            <input
              type="checkbox"
              checked={!!ai_listen && !!ai_sense}
              disabled={!ai_sense || aiSettingsLoading}
              onChange={handleToggleAIListen}
              style={{ width: 18, height: 18, cursor: ai_sense ? 'pointer' : 'not-allowed' }}
            />
            <span
              style={{
                fontSize: 13,
                fontWeight: 600,
                opacity: ai_sense ? 1 : 0.5
              }}
            >
              AI Listen
            </span>
          </label>
        ) : null}
      </div>


      <div className="p-2">
        <NavItem>
          <NavLink
            onClick={() => {
              readunread(user);
            }}
            className="nav-link"
            {...notification}
          >
            <NavbarVerticalMenuItem
              route={{
                ...notification,
                badge: { text: Object.values(count).filter(n => n.status === true).length, color: 'danger' }
              }}
            />
          </NavLink>
        </NavItem>
      </div>

      {/* Existing Online/Offline button (unchanged) */}
      <div className="p-2">
        {toggle && isPaid ? (
          <div className="btn btn-success btn-sm" onClick={() => handleChange(false)}>
            {' '}
            Online
          </div>
        ) : isPaid ? (
          <div className="btn btn-danger btn-sm" onClick={() => handleChange(true)}>
            {' '}
            Offline
          </div>
        ) : null}
      </div>

      {/* Modals (existing + new) */}
      {modalContent && (
        <div className="modal-backdrop" onClick={closeModal}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <p style={{ fontSize: '16px' }}>{modalContent}</p>

            {/* ✅ Two-button layout: Confirm / Cancel */}
            <div className="d-flex justify-content-center mt-3" style={{ gap: 12 }}>
              <button onClick={confirmModal} className="btn btn-primary btn-sm" style={{ fontSize: '16px' }}>
                Confirm
              </button>
              <button onClick={closeModal} className="btn btn-outline-secondary btn-sm" style={{ fontSize: '16px' }}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Keep your styles, add a hint of polish */}
      <style jsx>{`
        .modal-backdrop {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          padding: 16px;
        }
        .modal-content {
          background: #ffffff;
          padding: 20px 22px;
          border-radius: 12px;
          box-shadow: 0 10px 35px rgba(0, 0, 0, 0.18);
          text-align: center;
          max-width: 560px;
          width: 100%;
        }
        .ai-sense-chip {
          border-radius: 999px;
          padding-left: 14px;
          padding-right: 14px;
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
          transition: transform 0.05s ease, box-shadow 0.15s ease;
        }
        .ai-sense-chip:active {
          transform: translateY(1px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        }
      `}</style>

      {(isCombo || isTopNav) && (
        <NavItem className={classNames(`p-2 px-lg-0 cursor-pointer`, { [`d-${navbarBreakPoint}-none`]: isCombo })}></NavItem>
      )}

      <ProfileDropdown />
    </Nav>
  );
};

const mapStateToProps = state => ({
  toggle: state.Twilio.toggle,
  isPaid: state.auth.isPaid,
  isAuthenticated: state.auth.isAuthenticated,

  // ✅ NEW: ai settings slice
  ai_sense: state.aiSettings.ai_sense,
  ai_listen: state.aiSettings.ai_listen,
  aiSettingsLoading: state.aiSettings.loading
});

export default connect(mapStateToProps, {
  getuserStatus,
  postuserStatus,
  readunread,

  // ✅ NEW actions
  fetchAISettings,
  updateAISettings
})(TopNavRightSideNavItem);
